<div class="modal-header">
  <h4
    class="modal-title"
    translate
  >
    {{ title || 'Information' }}
  </h4>
  <button
    type="button"
    class="close btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss(false)"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-break">
  @if (isHtmlMessage) {
    <div [innerHTML]="message"></div>
  } @else {
    {{ message | translate }}
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary mx-auto"
    (click)="activeModal.close(false)"
    translate
  >
    {{ btnText || 'Close' }}
  </button>
</div>
